import backgroundImage from "../../back5.jpg";

export const DnaBackground = () => {
  return (
    <div
      className="fixed inset-0 -z-10 bg-background"
      aria-hidden="true"
    >
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-55"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
      <div className="absolute inset-0 bg-white/45" />
    </div>
  );
};
